import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = ({ children }: { children: React.ReactNode }) => (
  <TooltipPrimitive.Provider delayDuration={200}>{children}</TooltipPrimitive.Provider>
)

const Tooltip = TooltipPrimitive.Root
const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground shadow-lg",
      "transition-opacity duration-200 ease-in-out",
      "data-[state=delayed-open]:animate-fade-in data-[state=closed]:animate-fade-out",
      "data-[side=top]:animate-slide-in-from-bottom data-[side=bottom]:animate-slide-in-from-top",
      "data-[side=left]:animate-slide-in-from-right data-[side=right]:animate-slide-in-from-left",
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = "TooltipContent"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
